import { Theme } from '@interaction-gaming/planby'

export const theme: Theme = {
  primary: {
    600: 'white',
    900: 'transparent',
  },
  grey: { 300: '#101C2B' },
  white: '#fff',
  green: {
    300: '#2c7a7b',
    200: '#2c7a7b',
  },
  scrollbar: {
    border: '#ffffff',
    thumb: {
      bg: '#e1e1e1',
    },
  },
  loader: {
    teal: '#5DDADB',
    purple: '#3437A2',
    pink: '#F78EB6',
    bg: '#171923db',
  },
  gradient: {
    blue: {
      300: '#ffffff99',
      600: '#ffffff99',
      900: '#ffffff99',
    },
  },

  text: {
    grey: {
      300: '#121113',
      500: 'rgba(18, 17, 19, 0.50)',
    },
  },

  timeline: {
    divider: {
      bg: '#E7C951',
    },
  },
  teal: {
    100: '',
  },
  grid: {
    item: '#D0CDD7',
    divider: '#D0CDD7',
    highlight: '',
  },
}
